import { render, staticRenderFns } from "./dashBroad.vue?vue&type=template&id=519ba71c&scoped=true"
import script from "./dashBroad.vue?vue&type=script&lang=js"
export * from "./dashBroad.vue?vue&type=script&lang=js"
import style0 from "./dashBroad.vue?vue&type=style&index=0&id=519ba71c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ba71c",
  null
  
)

export default component.exports